export default __webpack_public_path__ + "static/media/bg-03.424b35be.jpg";